type EventPayload = Record<string, string | number | boolean | undefined>;

const cleanPayload = (payload: EventPayload) =>
  Object.fromEntries(Object.entries(payload).filter(([, value]) => value !== undefined)) as Record<
    string,
    string | number | boolean
  >;

export const pageMeta = {
  theme: "quiet_luxury_work_totes",
  page_id: "work_totes_v1",
};

export function trackEvent(eventName: string, payload: EventPayload = {}) {
  const eventData = cleanPayload({
    ...pageMeta,
    ...payload,
  });

  window.dataLayer?.push({
    event: eventName,
    ...eventData,
  });

  window.gtag?.("event", eventName, eventData);
  window.umami?.track(eventName, eventData);
}

export function getDestinationHost(url: string) {
  try {
    return new URL(url).host.replace(/^www\./, "");
  } catch {
    return "";
  }
}
